module.exports = __webpack_public_path__ + "img/mobile-neck-21_24x260.595ff53f.png";